import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatAnchor, MatButton } from '@angular/material/button';
import { UserService } from '../../../../../services/user.service';
import { map, Observable, of } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { environment } from '../../../../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ShipmentMapComponent } from '../../../../shipment-map/shipment-map.component';
import { Shipment } from '../../../../../pages/overview/models/shipment';

@Component({
  selector: 'app-scan-buttons',
  standalone: true,
  templateUrl: './scan-buttons.component.html',
  imports: [AsyncPipe, MatAnchor, MatButton],
  styleUrl: './scan-buttons.component.scss'
})
export class ScanButtonsComponent implements OnInit, OnChanges {
  @Input() openedFrom: 'Overview' | 'Shipments' | 'Containers' = 'Overview';
  @Input() shipment: Shipment | null = null;
  @Input() isArchived = false;
  isUserInternal$: Observable<boolean> = of(false);

  constructor(
    private userService: UserService,
    private matDialog: MatDialog
  ) {}

  scanViewUrl: string = '';
  scanBookUrl: string = '';

  ngOnInit() {
    this.isUserInternal$ = this.userService.getUserInfo().pipe(map(user => user.type === 'Internal'));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['shipment'].currentValue) {
      this.scanViewUrl = `${environment.scanViewUrl}${this.shipment?.scanViewId}`;
      this.scanBookUrl = `${environment.scanBookUrl}${this.shipment?.scanBookId}`;
    }
  }

  openMap() {
    const dialogRef = this.matDialog.open(ShipmentMapComponent, {
      height: '90vh',
      maxWidth: '1300px',
      width: '100%'
    });
    const instance = dialogRef.componentInstance;
    instance.shipment = this.shipment;
  }
}
